import * as React from "react";
import Styled from "styled-components/macro";
import Media from "@uizard-io/styled-media-query";
import Image, { GatsbyImageProps } from "gatsby-image";
import Button from "../../../../components/buttons/Button";
import MediaQuery from "../../../layout/MediaQuery";
import Tagline from "../../../texts/Tagline";
import Content from "../../../layout/Content/Content";
import Headline from "../../../texts/Headline";
import Description from "../../../texts/Description";
import RichDescription from "../../../texts/RichDescription";

const Container = Styled.div`
  margin: 0 0 16rem 0;
  
  ${Media.lessThan("medium")`
    margin: 0 0 9rem 0;
  `}
  
  ${Media.lessThan("small")`
    margin: 0 0 7rem 0;
  `}
`;

const Box = Styled.div`
  background: ${(props) => props.theme.colors.gray.lighter};
  padding: 3rem 0 0 0;
  border-radius: 2rem;
  
  ${Media.greaterThan("medium")`
    padding: 6rem 0 0 0;
  `}
`;

const Text = Styled.div`
  width: 64rem;
  max-width: calc(100% - 4rem);
  margin: 0 auto;
  
  ${Media.greaterThan("large")`
    width: 85rem;
  `}
`;

const TaglineExtended = Styled(Tagline)`
  text-align: center;
  color: #7f7f7f;
`;

const HeadlineExtended = Styled(Headline)`
  text-align: center;
`;

const DescriptionExtended = Styled(Description)`
  text-align: center;
  margin: 0 0 5rem 0;
  
    ${Media.lessThan("small")`
    margin: 0 0 3rem 0;
  `}
  
  ${Media.greaterThan("medium")`
    margin: 0 0 5rem 0;
  `}
`;

const ImageExtended = Styled(Image)`
  width: 102rem;
  max-width: 100%;
  margin: 0 auto;
  box-shadow: 0px 10px 50px 0px rgba(79, 79, 79, 0.1);
`;

const ExtendedButton = Styled(Button)`
  margin-bottom: 5rem;
`;

const NavButtonLink = Styled.a`
  text-align: center;
  display: block;
`;

type HomeBrainstormingProps = {
  tagline?: string;
  headline: string;
  description: string;
  imageA: GatsbyImageProps;
  imageB: GatsbyImageProps;
  imageAlt: string;
  link?: string;
  tagAsTitle?: boolean;
};

const HomeTemplates = ({
  tagline,
  headline,
  description,
  imageA,
  imageB,
  imageAlt,
  link,
  tagAsTitle,
}: HomeBrainstormingProps) => (
  <Container>
    <Content>
      <Box>
        <Text>
          {tagline && tagAsTitle && (
            <TaglineExtended as="h1">{tagline}</TaglineExtended>
          )}
          {tagAsTitle && (
            <HeadlineExtended as="h2">{headline}</HeadlineExtended>
          )}

          {tagline && !tagAsTitle && (
            <TaglineExtended>{tagline}</TaglineExtended>
          )}
          {!tagAsTitle && <HeadlineExtended>{headline}</HeadlineExtended>}

          <RichDescription content={description} />

          {link && (
            <NavButtonLink href={link}>
              <ExtendedButton variant="primarylight" solid>
                Read more
              </ExtendedButton>
            </NavButtonLink>
          )}
        </Text>

        <MediaQuery lessThan="medium">
          <ImageExtended
            fluid={"fluid" in imageB ? imageB.fluid : null}
            alt={imageAlt}
          />
        </MediaQuery>

        <MediaQuery greaterThan="medium">
          <ImageExtended
            fluid={"fluid" in imageA ? imageA.fluid : null}
            alt={imageAlt}
          />
        </MediaQuery>
      </Box>
    </Content>
  </Container>
);

export default HomeTemplates;
